<template>
  <div class="col-xs-12 col-sm-6 col-md-4 col-print-6">
    <div class="panel panel-primary panel-travel">
      <a v-bind:href="url" :target="target">
        <div class="panel-image" style="aspect-ratio: 16/9">
          <responsive-concrete-image v-if="tripData.overrides && tripData.overrides.imagePath"
                            :src="tripData.overrides.imagePath"
                            :available-thumbnails='tripData.overrides.imagePaths'
                            :aspect-ratio="16/9"
                            img-class="travel-preview-picture img-responsive"/>
          <responsive-image v-else-if="tripData.bilder"
                            :src="tripData.bilder.jpg_fallback_16x9"
                            :src-xs="tripData.bilder.img800_16x9"
                            :src-sm="tripData.bilder.img400_16x9"
                            :src-md="tripData.bilder.img400_16x9"
                            :src-lg="tripData.bilder.img400_16x9"
                            :fixed-aspect-ratio="16/9"
                            img-class="travel-preview-picture img-responsive"/>
          <div class="panel-image-overlays" v-if="!tripData.overrides || !tripData.overrides.hideLabels">
            <i v-if="tripData.overrides && tripData.overrides.icon && tripData.overrides.icon != '.no icon'"
               :class="'icon ' + tripData.overrides.icon + ' circle icon-overlay-right'"></i>
            <i v-else-if="tripData.icon && tripData.icon != '.no icon'"
               :class="'icon ' + tripData.icon + ' circle icon-overlay-right'"></i>
            <div class="label-guaranteed" v-if="isGuaranteed">
              Alle Abreisen garantiert
            </div>
            <div class="label-soldout" v-if="isFullyBooked">
              Ausgebucht
            </div>
            <div class="label-koenigsklasse" v-if="isKoenigsklasse"></div>
            <div class="label-komfortklasse" v-if="isKomfortklasse"></div>
            <div v-if="tripData.code" class="travel-remember"
                 :class="{selected: isRemembered}"
                 :data-code="tripData.code"
                 v-on:click.prevent="toggleRemember()"
                 :title="(isRemembered)?'Von Merkliste entfernen':'Auf Merkliste setzen'">
              <i class="icon very-small icon-pin"></i>
              <span class="text">Reise gemerkt</span>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="panel-content">
                <div v-if="tripData.overrides && tripData.overrides.content">
                  <requirement-rating v-if="tripData.schwierigkeitsgrad" title="Anforderungsprofil"
                                      :rating="tripData.schwierigkeitsgrad"/>
                  <div v-html="tripData.overrides.content"></div>
                </div>
                <div v-else>
                  <p v-if="tripData.schiff_rmt" class="ship-name">{{ tripData.schiff_rmt }}</p>
                  <h4>{{ tripData.tdbez }}</h4>
                  <p v-if="tripData.abreisedatentext" class="termine">{{ tripData.abreisedatentext }}</p>
                  <requirement-rating v-if="tripData.schwierigkeitsgrad" title="Anforderungsprofil"
                                      :rating="tripData.schwierigkeitsgrad"/>
                  <p class="description">{{ tripData.beschreibung }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tripData.overrides && tripData.overrides.promoContent" class="panel-highlighted" :class="'highlight-'+tripData.overrides.promoColorSet" v-html="tripData.overrides.promoContent">
        </div>
        <div class="panel-footer">
          <span class="btn btn-primary btn-arrow col-xs-12" v-html="button"></span>
        </div>
      </a>
    </div>
  </div>
</template>
<style></style>
<script type="module">
import ResponsiveImage from './_responsive-image.vue';
import AnalyticsMixin from '../mixins/analytics-mixin.js';
import RememberMixin from '../mixins/remember-mixin.js';
import TravelOverrideMixin from '../mixins/travel-override-mixin.js';

export default {
  name: "travel-tile-item",
  props: {
    tripData: {
      type: [ Object, Boolean ],
      default: false
    },
    uncompressed: {
      type: [ Boolean ],
      default: false
    }
  },
  mixins: [AnalyticsMixin, RememberMixin, TravelOverrideMixin],
  data: function () {
    return {
      isRemembered: false
    }
  },
  computed: {

  },
  methods: {

  },
  mounted(){

  },
  created() {

  },
  updated() {

  }
}
</script>